<template>
  <g>
    <path
      d="M21.71 11.2903L12.71 2.2903C12.32 1.9003 11.69 1.9003 11.3 2.2903L8.20996 5.3803L13 10.1703V7.5003L16.15 10.6503C16.35 10.8503 16.35 11.1603 16.15 11.3603L15.17 12.3403L18.62 15.7903L21.71 12.7003C22.09 12.3203 22.09 11.6903 21.71 11.2903Z"
    />
    <path
      d="M6.79 6.79027L3.51 3.51027C3.12 3.12027 2.49 3.12027 2.1 3.51027C1.71 3.90027 1.71 4.53027 2.1 4.92027L5.38 8.20027L2.29 11.2903C1.9 11.6803 1.9 12.3103 2.29 12.7003L11.29 21.7003C11.68 22.0903 12.31 22.0903 12.7 21.7003L15.79 18.6103L19.07 21.8903C19.46 22.2803 20.09 22.2803 20.48 21.8903C20.87 21.5003 20.87 20.8703 20.48 20.4803L6.79 6.79027ZM9.99 14.0003C9.99 14.5503 9.54 15.0003 8.99 15.0003C8.43999 15.0003 7.99 14.5503 7.99 14.0003V11.0003C7.99 10.9503 8.01 10.9003 8.02 10.8503L9.99 12.8203V14.0003Z"
    />
  </g>
</template>
